import { default as scroll } from './modules/_scroll';
import { default as headerEvents } from './modules/_header-events';
import { default as announcements } from './modules/_announcements';
import { default as modals } from './modules/_modals';
import { default as share } from './modules/_share';
import { default as search } from './modules/_search';
import { default as video } from './modules/_video';
import { default as toolTips } from './modules/_tool-tips';
import { init as iFrameTemplateInit } from './modules/_fullscreen-iframe';

(function () {

	scroll.init();
	headerEvents.init();
	announcements.init();
	modals.init();
	search.init();
	share.init();
	video.init();
  toolTips.init();

	iFrameTemplateInit();
	
})();
